module.exports = __webpack_public_path__ + "img/RepairSmart_White.03ae7d6c.png";